module.exports = __webpack_public_path__ + "static/img/FS.211d7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/FS.png
// module id = i9Up
// module chunks = 0